import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../SelectValue/Button";
import { Divider, Drawer } from "@mui/material";
import postService from "../../Services/post-service";
import swal from "sweetalert";
import Inputtt from "../SelectValue/Inputtt";
import NonnegativeInputField from "../SelectValue/NonnegativeInputfield";
import ImageUploader from "../Dropdown";
import getServices from "../../Services/get-service";

const desktopWidth = 650;

function AddInvestment({ open, handleClose, categoryId }) {
  const [loading, setLoading] = useState(false);
  
  const [name, setName] = useState("");
  const [details, setDetails] = useState("");
  const [selectedTenures, setSelectedTenures] = useState([]);
  const [minRate, setMinRate] = useState(""); 
  const [maxRate, setMaxRate] = useState(""); 
  const [unitPrice, setUnitPrice] = useState(""); 
  const [totalUnits, setTotalUnits] = useState(""); 
  const [targetAmount, setTargetAmount] = useState(""); 
  const [riskRating, setRiskRating] = useState(""); 

  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  
  const [allInvestment, setAllInvestment] = useState([]);

  const labelStyle = "mb-2 block text-sm md:text-base font-medium text-gray-700"; 

  const tenureOptions = Array.from({ length: 12 }, (_, i) => String(i + 1));

  const handleTenureSelect = (e) => {
    const value = e.target.value;
    if (!value) return;
    if (!selectedTenures.includes(value)) {
      setSelectedTenures((prev) => [...prev, value].sort((a, b) => Number(a) - Number(b)));
    }
    e.target.value = "";
  };

  const removeTenure = (month) => {
    setSelectedTenures((prev) => prev.filter((t) => t !== month));
  };

  const finalSubmit = (e) => {
    e.preventDefault();
    if (images.length === 0) return swal("Please select an investment image");
    if (selectedTenures.length === 0) return swal("Please select at least one tenure month");

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", details);
    selectedTenures.forEach((month) => {
      formData.append("acceptedTenureMonths", month);
    });
    formData.append("minRate", minRate);
    formData.append("maxRate", maxRate);
    formData.append("unitPrice", unitPrice);
    formData.append("totalUnits", totalUnits);
    formData.append("targetAmount", targetAmount); 
    formData.append("riskRating", riskRating); 
    formData.append("categoryId", category);

    images.forEach((image) => {
      formData.append("images", image); 
    });

    setLoading(true);
    postService.CreateInvestmentPlan(formData).then(
      (response) => {
        setLoading(false);
        if (response.data.status === "2000") {
          swal("Success", response.data.description, "success").then(() => {
            window.location.reload();
          });
        } else {
          swal("Error", response.data.description, "error");
        }
      },
      () => {
        setLoading(false);
        swal("Error", "Something went wrong, try again", "error");
      }
    );
  };

  useEffect(() => {
    getServices.getAllInvestments().then((response) => {
      if (response.data.status === "2000") {
        setAllInvestment(response.data.data || []);
      }
    });
  }, []);

  useEffect(() => {
    if (open && categoryId) {
      setCategory(categoryId);
    }
  }, [open, categoryId]);

  return (
    <Drawer
      anchor="right"
      variant="temporary"
      open={open}
      onClose={handleClose}
      sx={{ 
        "& .MuiDrawer-paper": { 
          boxSizing: "border-box", 
          width: {
            xs: "100%",
            sm: "80%",
            md: desktopWidth
          }, 
          backgroundColor: "white" 
        } 
      }}
    >
      <div className="px-4 h-full flex flex-col">
        <div className="flex my-4 justify-between items-center px-2">
          <h1 className="text-xl md:text-2xl font-bold text-back-color2">Add Investment Plan</h1>
          <div className="p-2 hover:bg-gray-100 rounded-full cursor-pointer" onClick={handleClose}>
            <CloseIcon />
          </div>
        </div>
        <Divider />

        <div className="px-3 md:px-5 pt-3 flex-1 overflow-y-auto">
          <form onSubmit={finalSubmit} className="mt-5 pb-20">
            
            <div className="grid my-4">
              <Inputtt label="Plan Name" value={name} onChange={setName} />
            </div>

            <div className="grid my-4">
              <label className={labelStyle}>Description</label>
              <textarea
                className="border p-3 md:p-4 outline-0 rounded-lg w-full h-32 text-sm md:text-base focus:border-blue-500 transition-all"
                value={details}
                required
                onChange={(e) => setDetails(e.target.value)}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 my-4">
              <NonnegativeInputField label="Min Rate (%)" valuee={minRate} onChange={setMinRate} />
              <NonnegativeInputField label="Max Rate (%)" valuee={maxRate} onChange={setMaxRate} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 my-4">
              <NonnegativeInputField label="Unit Price (₦)" valuee={unitPrice} onChange={setUnitPrice} />
              <NonnegativeInputField label="Total Units" valuee={totalUnits} onChange={setTotalUnits} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 my-4">
              <NonnegativeInputField label="Target Amount (₦)" valuee={targetAmount} onChange={setTargetAmount} />
              <div>
                <label className={labelStyle}>Risk Rating</label>
                <select
                  required
                  className="w-full bg-white border outline-0 p-3 rounded-lg text-sm md:text-base h-[50px]"
                  value={riskRating}
                  onChange={(e) => setRiskRating(e.target.value)}
                >
                  <option value="">Select Risk</option>
                  <option value="LOW">Low Risk</option>
                  <option value="MEDIUM">Medium Risk</option>
                  <option value="HIGH">High Risk</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 my-4">
              <div>
                <label className={labelStyle}>Tenure (Months)</label>
                <select
                  className="w-full bg-white border outline-0 p-3 rounded-lg text-sm md:text-base h-[50px]"
                  onChange={handleTenureSelect}
                  defaultValue=""
                >
                  <option value="">Add month</option>
                  {tenureOptions.map((month) => (
                    <option
                      key={month}
                      value={month}
                      disabled={selectedTenures.includes(month)}
                    >
                      {month} {Number(month) === 1 ? "month" : "months"}
                    </option>
                  ))}
                </select>

                {selectedTenures.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {selectedTenures.map((month) => (
                      <span
                        key={month}
                        className="inline-flex items-center gap-1 bg-purple-100 text-purple-700 text-xs font-medium px-2.5 py-1 rounded-full"
                      >
                        {month} {Number(month) === 1 ? "month" : "months"}
                        <button
                          type="button"
                          onClick={() => removeTenure(month)}
                          className="hover:text-purple-900 focus:outline-none leading-none"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <label className={labelStyle}>Category</label>
                <select
                  required
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="border w-full p-3 rounded-lg bg-white outline-0 text-sm md:text-base h-[50px]"
                >
                  <option value="">Select Category</option>
                  {allInvestment.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-6">
              <label className={labelStyle}>Cover Image</label>
              <ImageUploader images={images} setImages={setImages} />
            </div>

            <div className="flex my-8 justify-end border-t pt-6 mb-10">
              <div className="w-full sm:w-auto">
                <Button 
                  type="submit" 
                  name={loading ? "Processing..." : "Create Investment Plan"} 
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </Drawer>
  );
}

export default AddInvestment;